import repository from "../Repository";

export default {
  async registerTmpQrcode(screenId, payload) {
    const res = await repository.patch(`tmp_qrcode_upload`, payload, {
      headers: { s: screenId }
    });
    return res;
  }
};
